<template>
    <div class="body-container">
        <BannerSection title="Préstamo prendario automotor"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Préstamo prendario automotor</b></h1>
                    <p class="regular-text">
                        ¿Sabías que tu auto puede ayudarte a obtener dinero rápido sin necesidad de venderlo? Muchas
                        personas desconocen que pueden aprovechar el valor de su vehículo para acceder a financiamiento
                        inmediato. En este artículo te explicamos <b>qué es un préstamo prendario automotor</b>, cómo
                        funciona y cómo obtenerlo fácilmente con Ibancar.
                    </p>
                    <p class="regular-text">
                        Aquí te contaremos todo lo que necesitas saber para solicitar uno, asegurarte de hacerlo de
                        manera segura y encontrar las mejores opciones cerca de ti.
                    </p>
                    <br>
                    <span>
                        <h2 class="h2-title"><b>¿Qué es un Préstamo Prendario Automotor y cómo funciona?</b></h2>
                    </span>
                    <p class="regular-text">
                        Un <b>préstamo prendario automotor</b> es un tipo de financiamiento en el que utilizas tu auto como
                        respaldo para obtener dinero. Esto significa que puedes acceder a un crédito sin vender tu
                        vehículo y, lo mejor de todo, con el préstamo de Ibancar <b>sigues manejándolo</b> mientras pagas el
                        préstamo.
                    </p>
                    <p class="regular-text">
                        El proceso es simple:
                    </p>
                    <ol>
                        <li class="regular-text">
                            <p class="regular-text"><b>Solicitas tu préstamo en línea</b> proporcionando información
                                sobre tu auto.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Evaluamos el valor de tu vehículo</b> según su modelo, año y
                                estado.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Revisión técnica y firma del contrato</b>, sin salir de casa.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Recibes el dinero en menos de 24 horas</b> en tu cuenta.</p>
                        </li>
                    </ol>
                    <p class="regular-text">Este tipo de préstamo es ideal si necesitas dinero urgente y quieres evitar
                        trámites complicados o revisiones de crédito innecesarias.</p>
                    <br>

                    <h2 class="h2-title"><b>Beneficios de un Préstamo Prendario con Ibancar</b></h2>

                    <p class="regular-text">A diferencia de otras opciones de financiamiento, en Ibancar te ofrecemos un
                        proceso <b>rápido, seguro y sin complicaciones</b>. Estas son algunas de las ventajas de solicitar tu
                        préstamo con nosotros: </p>
                    <ul>
                        <li class="regular-text">
                            <p class="regular-text"><b>Sigues manejando tu aut</b>o mientras realizas los pagos.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Aunque revisamos tu Buró de Crédito</b>, el valor de tu auto
                                puede compensar tu situación.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Aprobación inmediata</b>, con respuesta en minutos.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Recibes el dinero en menos de 24 horas</b></p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Solicitud 100% en línea</b>, sin necesidad de acudir a
                                sucursales.</p>
                        </li>
                        <li class="regular-text">
                            <p class="regular-text"><b>Nosotros vamos a ti</b>, sin que tengas que salir de casa. </p>
                        </li>
                    </ul>

                    <br>
                    <h2 class="h2-title">
                        <b>¿Cuáles son los requisitos para obtener tu préstamo?</b>
                    </h2>
                    <p class="regular-text">Solicitar un <b>préstamo automotor</b> con Ibancar es muy sencillo. Solo
                        necesitas cumplir con estos requisitos básicos:</p>
                    <ol>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                Tener un auto modelo <b> 2007 en adelante, con hasta 250,000 km</b>.
                            </p>
                        </li>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                Contar con la <b>factura original del vehículo</b> (de agencia o refactura).
                            </p>
                        </li>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                Presentar tu <b>INE vigente.</b>
                            </p>
                        </li>
                        <li class=" regular-text">
                            <p class=" regular-text">
                                Proporcionar un <b>comprobante de domicilio e ingresos.</b>
                            </p>
                        </li>
                    </ol>
                    <p class="regular-text">Con estos documentos, puedes iniciar tu solicitud en línea y obtener tu
                        préstamo en cuestión de horas.</p>

                        <br>
                    <h2 class="h2-title">
                        <b>¿Cuánto dinero puedes obtener por tu automóvil?</b>
                    </h2>
                    <p class="regular-text">El monto que puedes recibir depende del valor de tu vehículo. En Ibancar
                        ofrecemos préstamos desde <b>$12,000 hasta $120,000</b> pesos, considerando el modelo, año y estado del
                        auto..</p>
                    <p class="regular-text">Si necesitas liquidez rápida sin vender tu coche, un préstamo prendario
                        automotor es la mejor opción. <b>Solicita el tuyo hoy mismo y recibe tu dinero en un solo día.</b></p>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <br>
                    <span class="bold-text">
                        <br>
                        <b>
                            <h2 class="h2-title">FAQs sobre el Préstamo personal</h2>
                        </b>
                        <br>
                    </span>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Debo dejar mi auto mientras pago el préstamo?</p>
                        <p class="regular-text">No, con Ibancar <b>sigues manejando tu auto</b>, mientras realizas los pagos.
                            No funcionamos exactamente como una casa de empeños</p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Cuánto tiempo tarda en aprobarse el préstamo?
                        </p>
                        <p class="regular-text">En minutos recibes una <b>preaprobación inmediata</b>, y el dinero se
                            transfiere en <b>menos de 24 horas</b>. </p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Puedo obtener un préstamo si tengo otro crédito activo?</p>
                        <p class="regular-text">Sí, en Ibancar aceptamos clientes con otros créditos, siempre que
                            cumplan con el resto de requisitos ya mencionados.
                        </p>
                    </div>
                    <br>
                    <p class="regular-text">Si necesitas dinero rápido y tienes un auto, un <b>préstamo prendario
                            automotor</b> es la solución ideal. Con Ibancar obtienes financiamiento de forma fácil, sin
                        trámites complicados y con la seguridad de seguir usando tu coche. </p>
                    <p class="regular-text"><b>Solicita tu préstamo hoy mismo y recibe tu dinero en 24 horas.</b></p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamoPrendarioAutomotor',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Que es un prestamo prendario automotor | IBANCAR',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Obtén un préstamo prendario automotor con tu coche como garantía. Sin buró, con aprobación rápida y sin dejar de usar tu vehículo. ¡Solicita tu crédito hoy!'
                    },
                    {
                        name: 'keywords',
                        content: 'que es un prestamo prendario automotor, prestamo automotor'
                    }
                ],
                link: [
                    { href: 'https://ibancar.mx/prestamo-prendario-automotor', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 15px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>